import { useEffect, useRef } from "react";
import {
  TELEMETRY_CATEGORIES,
  TELEMETRY_EVENTS,
  trackEvent,
  trackPerformanceMetric,
} from "../../telemetry";

export function useRouteTelemetry({ route, hash, previousRouteId }) {
  const navigationStartedAtRef = useRef(performance.now());
  const previousHashRef = useRef(hash);

  useEffect(() => {
    if (previousHashRef.current !== hash) {
      trackEvent(
        TELEMETRY_EVENTS.ROUTE_NAVIGATION,
        {
          fromRouteId: previousRouteId ?? null,
          toRouteId: route.id,
          hash,
          workspace: Boolean(route.workspace),
        },
        {
          category: TELEMETRY_CATEGORIES.NAVIGATION,
          dedupeKey: `${previousHashRef.current}->${hash}`,
        },
      );
      navigationStartedAtRef.current = performance.now();
      previousHashRef.current = hash;
    }
  }, [hash, previousRouteId, route.id, route.workspace]);

  useEffect(() => {
    const durationMs = Math.round(performance.now() - navigationStartedAtRef.current);

    trackEvent(
      TELEMETRY_EVENTS.ROUTE_VIEW,
      {
        routeId: route.id,
        hash,
        workspace: Boolean(route.workspace),
        documentTitle: route.documentTitle,
      },
      {
        category: TELEMETRY_CATEGORIES.NAVIGATION,
        context: {
          routeId: route.id,
          toolId: route.workspace ? route.id : undefined,
        },
        dedupeKey: `${route.id}:${hash}`,
      },
    );

    trackPerformanceMetric(
      route.workspace ? "workspace_route_load" : "route_load",
      {
        routeId: route.id,
        durationMs,
        workspace: Boolean(route.workspace),
      },
      {
        context: {
          routeId: route.id,
          toolId: route.workspace ? route.id : undefined,
        },
        dedupeKey: `${route.id}:${durationMs}`,
      },
    );
  }, [hash, route.documentTitle, route.id, route.workspace]);
}
